import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Translation } from 'react-i18next';
import {
  getAuthState,
  getOnboardingState,
  getTenantState,
} from '../../store/selectors';
import { setUser, setAuthStatus, checkUser } from '../../store/actions';
import me3Logo from '../../ASUPhotos/logos/me3_logo_black_NEW.png';
import RouteBack from '../utility/RouteBack';
import CampusBackground from '../CampusBackground';
import IntroImage from '../IntroImage';
import PoweredBy from '../utility/PoweredBy';
import validate from '../utility/CheckError';
import ErrorMessage from '../ErrorMessage';
import { fireGTM } from '../../gtm/gtmUtil';
import { getSSOProvider } from '../utility/getSSOProvider';
import { submitButton_GTM } from '../../gtm/datalayers/utilDataLayers.json';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      errorsPresent: false,
      errors: {
        emailNotInUse: false,
        emailInvalid: false,
        emailEmpty: false,
      },
      showLoginPrompt: false,
      showForgotPasswordPrompt: false,
      emailIsSSO: false,
      emailExists: true,
    };
    this.handleErrors = this.handleErrors.bind(this);
  }

  forgotPasswordHandler = async (event) => {
    event.preventDefault();
    await this.checkForSSOUser();
    await this.checkErrors();

    if (!this.state.errorsPresent && !this.state.emailIsSSO) {
      try {
        fireGTM(submitButton_GTM, 'submit', 'forgot your password?');
        await Auth.forgotPassword(this.state.email);
        this.props.history.push('verify');
      } catch (error) {
        console.error(error);
      }
    }
  };

  async checkForSSOUser() {
    await this.props.checkUser(this.state.email);
    const ssoProvider = await getSSOProvider(
      this.props.onboarding.cognitoUsername,
      this.props.tenant.name
    );

    if (ssoProvider === 'noCog') {
      this.setState({
        emailIsSSO: ssoProvider,
        emailExists: false,
      });
    } else {
      this.setState({
        emailIsSSO: ssoProvider,
        emailExists: true,
      });
    }
  }

  onInputChange = (event) => {
    this.setState({
      email: event.target.value.toLowerCase(),
    });
  };

  async checkErrors() {
    const { errors } = this.state;
    let pageHasErrors;

    if (Object.values(errors).indexOf(true) > -1) {
      pageHasErrors = true;
    } else {
      pageHasErrors = false;
    }

    this.setState({
      errorsPresent: pageHasErrors,
    });
  }

  async handleErrors(event, inputValue) {
    const errorsCopy = _.cloneDeep(this.state.errors);
    const stateCopy = _.cloneDeep(this.state);
    const error = await validate(
      event.target.id,
      inputValue,
      errorsCopy,
      stateCopy
    );

    this.setState(
      () => ({
        errors: { ...error },
      }),
      () => {
        this.checkErrors();
      }
    );
  }

  visitLink() {
    const me3Link = 'https://me3.careers';

    window.open(me3Link, '_blank');
  }

  render() {
    const { errors, emailIsSSO, emailExists } = this.state;
    const primaryBackground = {
      backgroundColor: this.props.tenant.primary,
    };

    const primaryBorder = {
      borderTop: `5px solid ${this.props.tenant.primary}`,
    };

    const primaryColor = {
      color: `${this.props.tenant.primary}`,
    };
    const secondaryBorder = {
      borderBottom: `5px solid ${this.props.tenant.secondary}`,
      padding: '0 5px',
    };

    return (
      <Translation>
        {(t) => (
          <CampusBackground secondaryColor={this.props.tenant.secondary}>
            {/* it would be nice to eventually have this component have it's own scss but since it's sharing... this will have to do for now */}
            <div className="login-page">
              <div className="login-left" style={primaryBorder}>
                <div className="content">
                  <div className="header-container">
                    <RouteBack
                      color={this.props.tenant.primary}
                      route="/login"
                      tenant={this.props.tenant}
                      section="forgot your password?"
                      text="back"
                    />
                    <div
                      role="link"
                      className="me3-link invisible-focus-indicator"
                      onClick={this.visitLink}
                      onKeyDown={(e) => {
                        if (['Enter'].includes(e.key)) this.visitLink();
                      }}
                      tabIndex="0"
                    >
                      {/* <img
                        className="me3-logo-mobile"
                        src={me3Logo}
                        alt="me3"
                      /> */}
                      <picture>
                        <source
                          media="(max-width: 799px)"
                          srcSet={me3Logo}
                          width="480"
                          height="400"
                        />
                        <source
                          media="(min-width: 800px)"
                          srcSet={me3Logo}
                          width="800"
                          height="400"
                        />
                        <img
                          className="me3-logo-mobile"
                          src={me3Logo}
                          alt="me3"
                          width="800"
                          height="400"
                        />
                      </picture>
                    </div>
                    <div className="login-text-container">
                      <h1 className="login-header-text">
                        {t('Forgot Your Password?')}
                      </h1>
                      <h1 className="login-header-text-mobile">
                        {t('Forgot Password')}
                      </h1>
                      <div
                        className="header-text-yellow-bar"
                        style={secondaryBorder}
                      />
                    </div>
                  </div>
                  <form
                    className="login-form"
                    onSubmit={this.forgotPasswordHandler}
                    noValidate
                  >
                    <div className="login-fields-container">
                      <div className="label-and-error">
                        <p className="login-text" style={primaryColor}>
                          {t('Email')}
                        </p>
                        <span
                          style={{
                            display: errors.emailNotInUse ? '' : 'none',
                          }}
                        >
                          <ErrorMessage error={t('Email not found')} />
                        </span>
                        <span
                          style={{ display: errors.emailInvalid ? '' : 'none' }}
                        >
                          <ErrorMessage error={t('Email invalid')} />
                        </span>
                        <span
                          style={{ display: errors.emailEmpty ? '' : 'none' }}
                        >
                          <ErrorMessage error={t('Field required')} />
                        </span>
                        <span
                          style={{
                            display: emailIsSSO ? '' : 'none',
                          }}
                          className={emailIsSSO ? 'sso-provider' : ''}
                        >
                          <ErrorMessage
                            error={
                              emailExists
                                ? t(
                                    `You created this account using ${this.state.emailIsSSO}. Please update your password with ${this.state.emailIsSSO}.`
                                  )
                                : t(`Please register your mail id`)
                            }
                          />
                        </span>
                      </div>
                      <div className="input-container">
                        <input
                          type="email"
                          id="email"
                          data-cy="email"
                          aria-describedby="emailHelp"
                          placeholder={t('Enter email')}
                          tabIndex="0"
                          onChange={this.onInputChange}
                          onBlur={(event) => {
                            this.handleErrors(event, this.state.email);
                          }}
                          className={
                            this.state.errorsPresent ? 'error input' : 'input'
                          }
                        />
                      </div>
                    </div>
                    <div className="input-bottom">
                      <div className="login-button-container">
                        <button
                          style={primaryBackground}
                          className="button--primary login-button"
                          id="submit"
                          type="submit"
                          data-cy="submit"
                        >
                          {t('Submit')}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <PoweredBy tenant={this.props.tenant} />
              </div>
            </div>

            <IntroImage showTutorial={false} />
          </CampusBackground>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const auth = getAuthState(state);
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);

  return { auth, onboarding, tenant };
};

const ForgotPasswordWithRouter = withRouter(
  connect(mapStateToProps, { setAuthStatus, setUser, checkUser })(
    ForgotPassword
  )
);

export default ForgotPasswordWithRouter;
